import styled from "styled-components";
import colors from "../../theme/color/ColorTheme";
import DesktopNavbar from "./DesktopNavbar";
import TopBar from "./TopBar";

const Wrapper = styled.div`
  width: 100%;
  position: fixed;
  background-color: ${colors.backgroundPrimary};
  z-index: 99;
`;
const NavContainer = styled.div``;

function Navbar() {
  return (
    <>
      <Wrapper>
        <TopBar />
        <NavContainer>
          <DesktopNavbar />
        </NavContainer>
      </Wrapper>
      <div style={{ paddingTop: "170px" }}></div>
    </>
  );
}

export default Navbar;
